<div class="container cust-container">

  <div class="nav-wrapper breadcrumbshc">


    <a routerLink="/logintype" class="breadcrumb"> &nbsp;&nbsp;&nbsp; Logout</a>

  </div>

  <div class="row middle-content" id="access-denied-page">
    <div class="col-lg-12">
      <div class="ad-container" style="text-align: center;margin-top:10%">
        <i class="fa fa-warning"></i>
        <h2>Kindly request administrator to get access to this content.</h2>
      </div>
    </div>

  </div>
</div>